import { queryOptions, useQuery } from '@tanstack/react-query';
import { getInstantStatistics, mapInstantStatistics } from '@/services/api/instant-trade';

export const INSTANT_STATISTICS_QUERY_KEY = ['instant-trade', 'statistics'] as const;

export const instantStatisticsQueryOptions = () =>
  queryOptions({
    queryKey: INSTANT_STATISTICS_QUERY_KEY,
    queryFn: getInstantStatistics,
    select: mapInstantStatistics,
  });

export const useInstantStatistics = () => useQuery(instantStatisticsQueryOptions());
